export default function MedalBadge({ rank }) {
  const baseStyle = {
    height: 32,
    width: 32,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 700,
    fontSize: 12,
    border: "2px solid rgba(255,255,255,0.3)",
  };

  if (rank === 1) {
    return (
      <div
        style={{ ...baseStyle, backgroundColor: "#f5ca41", color: "#1a1a1a" }}
      >
        1
      </div>
    );
  }

  if (rank === 2) {
    return (
      <div
        style={{ ...baseStyle, backgroundColor: "#C0C0C0", color: "#1a1a1a" }}
      >
        2
      </div>
    );
  }

  if (rank === 3) {
    return (
      <div style={{ ...baseStyle, backgroundColor: "#CD7F32", color: "#fff" }}>
        3
      </div>
    );
  }

  return (
    <div
      style={{
        ...baseStyle,
        backgroundColor: "#1C2A37",
        border: "2px solid #2A4051",
        color: "var(--Primary-500)",
      }}
    >
      {rank}
    </div>
  );
}
